module.exports = __webpack_public_path__ + "img/3.6053e864.jpg";